import {http} from '../http'
import * as coreEzTexting from '../../coreApi/eztexting'
import {APIResponse} from '../types'
import {CheckCredentialsResponse, ResourceID} from '../../../types'
import {handleError} from '../handleError'

interface Params {
  clientID: ResourceID
}

type ResolvedReturn = APIResponse<CheckCredentialsResponse>

export interface ServiceMethod {
  (params: Params): Promise<ResolvedReturn>
}

const ERROR_PATH = 'api.eztexting.checkCredentials()'
const GENERIC_ERROR =
  'Something went wrong while getting your group. Please try again.'

export const checkCredentials: ServiceMethod = async ({clientID}) => {
  let resolvedReturn: ResolvedReturn

  try {
    const response = await coreEzTexting.checkCredentials(http, {
      ClientID: parseInt(clientID, 10),
    })
    if (!response || !response.data) {
      throw new Error('Unsuccessful checkCredentials')
    }
    resolvedReturn = {
      result: 'success',
      data: {
        clientID: response.data.ClientID.toString(),
        validated: response.data.Validated,
      },
    }
  } catch (e) {
    resolvedReturn = handleError(ERROR_PATH, GENERIC_ERROR, e, true)
  }

  return Promise.resolve(resolvedReturn)
}
